export default __webpack_public_path__ + "static/media/Hand_Wash.e2d29c72.jpg";